<div class="font-family-selector" (click)="$event.stopPropagation()">
  <div class="text-field flex-row gap-6" (click)="toggleSelector()">
    <div class="fs-13">{{ fontFamilyToDisplay }}</div>
    <nw-icon type="keyboard_arrow_down" [size]="14" color="white"></nw-icon>
  </div>
  <div class="selector" *ngIf="showSelector">
    <div class="position-absolute container">
      <input
        type="text"
        #search
        [(ngModel)]="searchText"
        (keyup)="searchTextChange($event)"
        (keydown)="$event.stopPropagation()"
      />

      <div class="font-list flex-column">
        <div
          *ngFor="let font of fonts$ | async"
          (click)="selectFont(font)"
          class="font-item"
        >
          {{ font.name }}
        </div>
        <div *ngIf="!(fonts$ | async)?.length" class="font-item">
          No font was found
        </div>
      </div>
    </div>
  </div>
</div>
